import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // Import Auth Context

const Home = () => {
  const { user } = useAuth(); // Get user status

  useEffect(() => {
    document.body.className = "";
  }, []);

  return (
    <main>
      {/* Hero Section */}
      <section className="hero-section" aria-label="Hero Section">
        <div className="container hero-content reveal-on-scroll">
          <div className="hero-text">
            <h1>Your AI-powered Health Companion, Elevated!</h1>
            <p>
              Our platform provides expert insights, virtual consultations, and
              personalized health tracking.
            </p>
            {/* Logic: If user is logged in, go to Plus, otherwise Signup */}
            <Link
              to={user ? "/floracare-plus" : "/signup"}
              className="btn btn-primary hero-cta"
            >
              Explore FloraCare+
            </Link>
          </div>
          <div className="hero-image">
            <img
              src="/hero_image.jpeg"
              alt="FloraCare Doctor"
              className="hero-actual-image"
            />
          </div>
        </div>
      </section>

      {/* Specialty Section */}
      <section
        className="specialty-section"
        aria-labelledby="specialty-heading"
      >
        <div className="container specialty-content">
          <h2 id="specialty-heading" style={{ textAlign: "center" }}>
            Our Services
          </h2>
          <p
            className="subtitle"
            style={{ textAlign: "center", marginBottom: "3rem" }}
          >
            We provide world-class digital health services, from essential care
            to premium support.
          </p>

          <div className="specialty-cards">
            {/* FloraCare+ Card */}
            <div className="card card-highlight">
              <div className="card-icon">
                <i className="fas fa-star"></i>
              </div>
              <h3>FloraCare+</h3>
              <p>
                Unlock personalized PCOD/PCOS coaching and exclusive home test
                kits.
              </p>
              {/* Dynamic Link Fixed Here */}
              <Link
                to={user ? "/floracare-plus" : "/signup"}
                className="btn btn-primary btn-small"
              >
                Discover Premium
              </Link>
            </div>

            {/* GyneCare Card */}
            <div className="card">
              <div className="card-icon">
                <i className="fas fa-female"></i>
              </div>
              <h3>GyneCare</h3>
              <p>
                Access specialized women's health services, cycle tracking, and
                expert consultations.
              </p>
              <Link to="/tracker" className="btn btn-outline btn-small">
                Explore GyneCare
              </Link>
            </div>

            {/* BabyCare Card */}
            <div className="card">
              <div className="card-icon">
                <i className="fas fa-baby"></i>
              </div>
              <h3>BabyCare</h3>
              <p>
                Track vaccinations, growth, milestones, and access essential
                baby resources.
              </p>
              <Link to="/babycare" className="btn btn-outline btn-small">
                Explore BabyCare
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
